import { CheckoutState } from '../../state';
import { getIsTransferredOrder } from './getIsTransferredOrder';
import { getAttendees } from './typedOrderSelectors';

export const getAttendeeDeliveryMethodsPayloadForPlacingOrder = (
    state: CheckoutState,
) => {
    const isTransferredOrder = getIsTransferredOrder(state);

    if (isTransferredOrder) {
        return null;
    }

    return getAttendees(state).map(({ id, deliveryMethod }) => ({
        attendee_id: id,
        delivery_method: deliveryMethod,
    }));
};
